/* istanbul ignore file */
export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID;

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const trackPageView = (url: URL) => {
  if (!GA_TRACKING_ID) return;

  window.gtag('config', GA_TRACKING_ID!, {
    page_path: url,
  });
};

type GTagEvent = {
  action: string;
  category?: string;
  label?: string;
  value?: number;
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const trackEvent = ({ action, category, label, value }: GTagEvent) => {
  if (!GA_TRACKING_ID) return;

  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

// https://support.google.com/analytics/answer/7478520?hl=en
export const trackExternalLink = (url: string) => {
  if (!GA_TRACKING_ID) return document.location.href = url;

  window.gtag('event', 'click', {
    'event_category': 'outbound',
    'event_label': url,
    'transport_type': 'beacon',
    'event_callback': function () { document.location.href = url; }
  });
}

type HubEventTrackingParams = {
  url: string
  hubId: string
  eventId: string
}
export const trackHubEventClick = ({ hubId, eventId, url }: HubEventTrackingParams) => {
  trackEvent({
    action: 'select_event',
    category: hubId,
    label: eventId,
  });

  return trackExternalLink(url);
}
